import { Card, Heading, Stack } from '@etg/wings';
import { DangerousHtmlContent, Overlay } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import CFCImportantNote from './CFCImportantNote';

const cardSectionStyles = css`
  border: none;
`;

interface CFCInfoDrawerProps {
  handleCloseDrawer: () => void;
  isDrawerOpen: boolean;
}

const CFCInfoDrawer = ({ handleCloseDrawer, isDrawerOpen }: CFCInfoDrawerProps) => {
  const { t } = useTranslation();
  const infoCards = [...Array(4)].map((_, index) => {
    return {
      title: t(`Payment.Ryanair.InfoDrawer.Card${index + 1}.Title`),
      description: t(`Payment.Ryanair.InfoDrawer.Card${index + 1}.Description`),
      note: t(`Payment.Ryanair.InfoDrawer.Card${index + 1}.Note.Text`),
    };
  });

  return (
    <Overlay.Drawer
      dataTestId="cfc-info-drawer"
      handleClose={handleCloseDrawer}
      isOpen={isDrawerOpen}
    >
      <Overlay.Header onClose={handleCloseDrawer} title={t('Payment.Ryanair.InfoDrawer.Title')} />
      <Overlay.Content>
        <Card>
          {infoCards.map((info) => (
            <Card.Section className={cardSectionStyles} key={info.title}>
              <Stack>
                <Heading level={3}>{info.title}</Heading>
                <DangerousHtmlContent content={info.description} />
                {info.note && (
                  <CFCImportantNote content={<DangerousHtmlContent content={info.note} />} />
                )}
              </Stack>
            </Card.Section>
          ))}
        </Card>
      </Overlay.Content>
    </Overlay.Drawer>
  );
};

export default CFCInfoDrawer;
